/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
export default class DashboardError {
  constructor(msg, date = new Date()) {
    this.msg = msg;
    this.date = date;
  }

  logToConsole() {
    console.error(this.toString());
  }

  getDateTimeString() {
    return this.date.toLocaleString();
  }

  toString() {
    return `${this.getDateTimeString()}: ${this.msg}`;
  }
}
